import { render, staticRenderFns } from "./ItemNew_Variants.vue?vue&type=template&id=c8fdcdd0&"
import script from "./ItemNew_Variants.vue?vue&type=script&lang=js&"
export * from "./ItemNew_Variants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports